import { FormattedMessage } from 'react-intl';

enum BankName {
  BankOfAmerica = 'Bank of America',
  BankOfMontreal = 'Bank of Montreal',
  CanadianImperialBankOfCommerce = 'Canadian Imperial Bank of Commerce',
  CentralOneCreditUnion = 'Central 1 Credit Union',
  FederationDesCaissesDesjardinsDuQuebec = 'Federation des caisses desjardins du Quebec',
  JPMorganChaseBank = 'JPMorgan Chase Bank',
  NationalBankOfCanada = 'National Bank of Canada',
  PlootoInstantCad = 'Plooto Instant (Canada - CAD)',
  PlootoInstantCanadaUsd = 'Plooto Instant (Canada - USD)',
  PlootoInstantUsUsd = 'Plooto Instant (US - USD)',
  RoyalBankOfCanada = 'Royal Bank of Canada',
  TheBankOfNovaScotia = 'The Bank of Nova Scotia',
  TheTorontoDominionBank = 'The Toronto-Dominion Bank',
}

enum CreditCardType {
  Visa = 'visa',
  Mastercard = 'mc',
}

enum DisplayStatusName {
  AttentionRequired = 'Attention Required',
  Locked = 'Locked',
  PINDepositFailed = 'PIN Deposit Failed',
  PINDepositPending = 'PIN Deposit Pending',
  Ready = 'Ready',
  VerificationRequired = 'Verification Required',
  Verified = 'Verified',
  Pending = 'Pending',
}

const INSUFFICIENT_PERMISSIONS_ERROR_TITLE = (
  <FormattedMessage defaultMessage="Insufficient Permissions" />
);
const INSUFFICIENT_PAYMENT_PERMISSIONS_ERROR_MESSAGE = (
  <FormattedMessage defaultMessage="Only users with payment permissions can transfer funds between accounts. Please contact your company administrator." />
);
const INSUFFICIENT_BANK_PERMISSIONS_ERROR_MESSAGE = (
  <FormattedMessage defaultMessage="Only users with add / edit bank account permissions can add a bank account. Please contact your company administrator." />
);

const NO_VERIFIED_ACCOUNT_ERROR_TITLE = 'Bank Verification Pending';
const NO_VERIFIED_ACCOUNT_ERROR_MESSAGE = (
  <FormattedMessage defaultMessage="Transferring funds between accounts is possible once you have a verified Bank Account." />
);

export {
  BankName,
  CreditCardType,
  DisplayStatusName,
  INSUFFICIENT_BANK_PERMISSIONS_ERROR_MESSAGE,
  INSUFFICIENT_PAYMENT_PERMISSIONS_ERROR_MESSAGE,
  INSUFFICIENT_PERMISSIONS_ERROR_TITLE,
  NO_VERIFIED_ACCOUNT_ERROR_TITLE,
  NO_VERIFIED_ACCOUNT_ERROR_MESSAGE,
};
